export const formatINR = (n) => {
  if (n === null || n === undefined) return '₹0';
  return `₹${Number(n).toLocaleString('en-IN')}`;
};

/**
 * Parse a backend timestamp into a Date. The API stores naive UTC strings
 * (e.g. "2026-06-04T07:37:37.500000" with no Z/offset); JS would otherwise read
 * those as the device's LOCAL time. We append 'Z' when there's no timezone
 * designator so the instant is correct, then callers render it in IST.
 */
export const parseDate = (iso) => {
  if (!iso) return null;
  if (iso instanceof Date) return iso;
  const s = String(iso);
  const hasTz = /([zZ])|([+-]\d{2}:?\d{2})$/.test(s);
  return new Date(hasTz ? s : s + 'Z');
};

export const formatINRShort = (n) => {
  if (!n) return '₹0';
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(1)}Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)}L`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(1)}k`;
  return `₹${n}`;
};

export const formatDateTime = (iso) => {
  const d = parseDate(iso);
  if (!d) return '-';
  return d.toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
    timeZone: 'Asia/Kolkata',
  });
};

export const formatDateShort = (iso) => {
  const d = parseDate(iso);
  if (!d) return '-';
  return d.toLocaleDateString('en-IN', {
    day: '2-digit', month: 'short',
    timeZone: 'Asia/Kolkata',
  });
};

export const shortId = (id) => (id ? `#${id.slice(-8).toUpperCase()}` : '-');

/** Prefer the customer-facing 7-char order_code; fall back to the legacy shortId. */
export const orderRef = (order) => {
  if (!order) return '-';
  if (order.order_code) return `#${order.order_code}`;
  return shortId(order._id);
};
